import React, { useState } from 'react';
import Typography from 'aldoo-ra/Typography';

/**
 * Action row component to handle action display and source viewing
 */
export default function ActionRow({ row }) {
    const [showPanel, setShowPanel] = useState(false);
    const [copied, setCopied] = useState(false);

    // Format the full action object for display
    let sourceStr;
    const action = row.fullAction;

    // Check if there's a raw source field (Lua code)
    if (action?.raw && typeof action.raw === 'string') {
        sourceStr = action.raw;
        // Remove outer braces and unindent content
        if (sourceStr.startsWith('{') && sourceStr.endsWith('}')) {
            let content = sourceStr.substring(1, sourceStr.length - 1);
            const lines = content.split('\n');
            const minIndent = lines
                .filter(line => line.trim().length > 0)
                .reduce((min, line) => {
                    const indent = line.match(/^\s*/)[0].length;
                    return indent < min ? indent : min;
                }, Infinity);
            if (minIndent > 0 && minIndent !== Infinity) {
                sourceStr = lines.map(line =>
                    line.length > minIndent ? line.substring(minIndent) : line
                ).join('\n').trim();
            } else {
                sourceStr = content.trim();
            }
        }
    } else if (action?.__raw && typeof action.__raw === 'string') {
        sourceStr = action.__raw;
        if (sourceStr.startsWith('{') && sourceStr.endsWith('}')) {
            let content = sourceStr.substring(1, sourceStr.length - 1);
            const lines = content.split('\n');
            const minIndent = lines
                .filter(line => line.trim().length > 0)
                .reduce((min, line) => {
                    const indent = line.match(/^\s*/)[0].length;
                    return indent < min ? indent : min;
                }, Infinity);
            if (minIndent > 0 && minIndent !== Infinity) {
                sourceStr = lines.map(line =>
                    line.length > minIndent ? line.substring(minIndent) : line
                ).join('\n').trim();
            } else {
                sourceStr = content.trim();
            }
        }
    } else if (typeof action === 'string') {
        sourceStr = action;
    } else if (action && typeof action === 'object') {
        sourceStr = JSON.stringify(action, null, 2);
    } else {
        sourceStr = String(action);
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(sourceStr);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <>
            <span
                className={`text-sm font-medium cursor-pointer hover:text-admin_info ${row.isActive ? 'text-admin_info font-bold' : 'text-admin_text'} flex items-center gap-2`}
                onClick={() => setShowPanel(true)}
            >
                {row.isActive && (
                    <svg className="animate-spin h-4 w-4 text-admin_info" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                )}
                {row.name}
            </span>
            {showPanel && (
                <>
                    <div
                        className="fixed inset-0 bg-black/50 z-[9998]"
                        onClick={() => setShowPanel(false)}
                    />
                    <div className="fixed z-[9999] bg-admin_canvas border border-admin_bordered rounded shadow-2xl p-4 min-w-[400px] max-w-[700px]"
                        style={{
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)'
                        }}
                    >
                        <div className="flex justify-between items-center mb-3">
                            <div className="flex items-center gap-2">
                                <Typography variant="admin_txt2" className="font-semibold">Action Source</Typography>
                                <button
                                    onClick={handleCopy}
                                    className="text-sm px-3 py-1 bg-admin_neutral_2 hover:bg-admin_neutral_3 text-admin_text rounded transition-colors"
                                >
                                    {copied ? 'Copied!' : 'Copy'}
                                </button>
                            </div>
                            <button
                                onClick={() => setShowPanel(false)}
                                className="text-admin_text_secondary hover:text-admin_text"
                            >
                                ✕
                            </button>
                        </div>
                        <div className="max-h-[500px] overflow-y-auto scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_canvas">
                            <pre className="text-xs text-admin_text font-mono whitespace-pre-wrap break-words">
{sourceStr}
                            </pre>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
